export default "__VITE_ASSET__DnMiM1jt__"